export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    isSelected (value) {
      return this.value === value
    }
  },
  computed: {
    meta () {
      return this.item.meta
    },
    itemName () {
      return 'item-' + this.item.id
    },
    isRequired () {
      return !!this.meta.required
    },
    validationRules () {
      return {
        required: this.isRequired
      }
    },
    value: {
      get () {
        return this.item.value
      },
      set (value) {
        let item = this.item
        item.value = value
        this.$store.commit('survey/ITEM_UPDATED', item)
      }
    }
  }
}
